import axios from 'axios'
import { ElMessage } from 'element-plus'

function shouldIgnoreMessage(msg) {
  return /ResizeObserver loop/i.test(String(msg || ''))
}

function friendlyUnhandledReason(reason) {
  if (axios.isAxiosError?.(reason)) {
    const msg = reason.message || ''
    if (msg === 'Network Error' || /Network Error/i.test(msg)) {
      return '网络连接失败，请检查网络或服务是否可用'
    }
    if (reason.code === 'ECONNABORTED' || /timeout/i.test(msg)) {
      return '请求超时，请稍后重试'
    }
    const data = reason.response?.data
    return data?.msg || data?.message || msg || '请求失败'
  }
  if (reason instanceof Error) return reason.message
  if (typeof reason === 'string') return reason
  return '系统异常，请稍后重试'
}

/**
 * 开发环境关闭 webpack 全屏遮罩后，用 Element Plus 承接未捕获异常与 Promise 拒绝。
 * Axios 在 request 拦截器里已提示的，不在此处重复弹窗。
 */
export function setupGlobalErrorHandlers(app) {
  app.config.errorHandler = (err, _instance, info) => {
    console.error('[Vue]', err, info)
    const msg = err?.message || String(err)
    if (shouldIgnoreMessage(msg)) return
    const display = msg.length > 160 ? msg.slice(0, 160) + '…' : msg
    ElMessage.error(display || '页面异常')
  }

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason
    event.preventDefault()
    if (axios.isAxiosError?.(reason)) {
      return
    }
    console.warn('[unhandledrejection]', reason)
    const msg = friendlyUnhandledReason(reason)
    if (shouldIgnoreMessage(msg)) return
    ElMessage.error(msg.length > 160 ? msg.slice(0, 160) + '…' : msg)
  })
}
